export const FOREX_TEMPLATE_MODULE_NAME: string = 'template';

export enum ForexTemplateGetter {
	list = 'list',
	loading = 'loading',
	currentTemplate = 'currentTemplate',
}

export enum ForexTemplateMutation {
	addList = 'addList',
	setLoading = 'setLoading',
	setNextPage = 'setNextPage',
	resetPage = 'resetPage',
	setIsEndPage = 'setIsEndPage',
	setList = 'setList',
	setCurrentTemplate = 'setCurrentTemplate',
	updateCurrentTemplate = 'updateCurrentTemplate',
	resetList = 'resetList',
	deleteTemplate = 'deleteTemplate',
	resetCurrentTemplate = 'resetCurrentTemplate',
}

export enum ForexTemplateAction {
	loadNextPage = 'loadDraftNextPage',
	loadPage = 'loadPage',
	reloadPage = 'reloadPage',
	loadAllPages = 'loadAllPages',
	updateCurrentTemplate = 'updateCurrentTemplate',
	createTemplate = 'createTemplate',
	deleteTemplate = 'deleteTemplate',
	deleteCurrentTemplate = 'deleteCurrentTemplate',
	loadTemplate = 'loadTemplate',
}